import React, { useEffect } from "react";
//Redux Imports
import { createStore, compose, combineReducers, applyMiddleware  } from "redux";

//Reducer is where the session will be stored
import loginReducer from "./reducers/loginReducer"; // we will set the user's AUTH token, which is sent by the server
import { sessionReducer } from 'redux-react-session';


//Custom Redux Middleware. 
import { appMiddleware } from "../middlewares/app"; //responsible for handling the app-specific functions like login
import { apiMiddleware } from "../middlewares/core";//core middleware is responsible for handling external API requests


/*
// Uncomment code if the Redux debug is not being used.

  const createStoreWithMiddleware = applyMiddleware(
    appMiddleware,
    apiMiddleware
  )(createStore);

  const store = createStoreWithMiddleware(reducer);

*/

// Comment code if the Redux debug is not being used.
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const reducers = combineReducers({
  login:loginReducer,
  session: sessionReducer
});
const store = createStore(loginReducer, /* preloadedState, */ composeEnhancers(
  applyMiddleware(
    appMiddleware,
    apiMiddleware
  )
));

export default store;